import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Tag, Typography, Spin, Modal, Button, Form, Select } from 'antd';
import { toast } from 'react-toastify';
import api from '../../api/roleFieldAssignment';
import { ROUTES } from '../../utils/constants';
import { SUB_PERMISSIONS } from '../../utils/constants';
import enumService from '../../api/enumService';
const { Title, Text } = Typography;

const RoleFieldAssignmentPage = () => {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);

  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editForm] = Form.useForm();
  const [editingAssignment, setEditingAssignment] = useState(null);
  const [roleTypes, setRoleTypes] = useState([]);
  const [userTypes, setUserTypes] = useState([]);

  const routeOptions = Object.values(ROUTES).map(value => value.startsWith('/') ? value.slice(1) : value);

  const subPermissionOptions = Object.values(SUB_PERMISSIONS);

  const openEditModal = (assignment) => {
    setEditingAssignment(assignment);
    editForm.setFieldsValue({
      roleName: assignment.roleName,
      roleAssignUserType: assignment.roleAssignUserType,
      fieldsAssigned: assignment.fieldsAssigned,
    });
    setEditModalVisible(true);
  };

  const handleEditSubmit = async () => {
    try {
      const values = await editForm.validateFields();
      const response = await api.updateRoleFieldAssignment(editingAssignment.id, values);
      if (response.success) {
        toast.success('Updated successfully');
        setEditModalVisible(false);
        fetchAssignments();
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  const fetchRoleTypes = async () => {
    setLoading(true);
    const response = await enumService.getRoleTypes();
    if (!response.success) {
      toast.error(response.message);
    } else {
      setRoleTypes(response.data.data);
    }
    setLoading(false);
  };

  const fetchUserTypes = async () => {
    setLoading(true);
    const response = await enumService.getUserTypes();
    if (!response.success) {
      toast.error(response.message);
    } else {
      setUserTypes(response.data.data);
    }
    setLoading(false);
  };

  const fetchAssignments = async () => {
    setLoading(true);
    const response = await api.getAllRoleFieldAssignments();
    if (!response.success) {
      toast.error(response.message);
    } else {
      setAssignments(response.data.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAssignments();
    fetchRoleTypes();
    fetchUserTypes();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 100 }}>
        <Spin tip="Loading..." />
      </div>
    );
  }

  return (
    <div style={{ padding: 20 }}>
      <Title level={2}>Role Field Assignments</Title>
      <Row gutter={[16, 16]}>
        {assignments.map((assignment) => (
          <Col
            key={assignment.id}
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={8}
          >
            <Card
              title={assignment.roleName}
              bordered
              hoverable
              style={{ height: '100%' }}
              extra={
                <Button type="link" onClick={() => openEditModal(assignment)}>
                  Edit
                </Button>
              }
            >
              <Text strong>User Type: </Text>
              <Tag color="blue">{assignment.roleAssignUserType}</Tag>

              <div style={{ marginTop: '10px' }}>
                <Text strong>Fields Assigned:</Text>
                <div style={{ marginTop: 8 }}>
                  {assignment.fieldsAssigned.map((field, index) => (
                    <Tag color="green" key={index} style={{ marginBottom: 5 }}>
                      {field}
                    </Tag>
                  ))}
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      <Modal
        title="Edit Role Field Assignment"
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        onOk={handleEditSubmit}
        okText="Update"
      >
        <Form form={editForm} layout="vertical">
          <Form.Item
            name="roleName"
            label="Role Name"
            rules={[{ required: true, message: 'Please select role type' }]}
          >
            <Select placeholder="Select role type">
              {roleTypes.map((type) => (
                <Option key={type} value={type}>
                  {type}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="roleAssignUserType"
            label="User Type"
            rules={[{ required: true, message: 'Please select user type' }]}
          >
            <Select placeholder="Select user type">
              {userTypes.map((type) => (
                <Option key={type} value={type}>
                  {type}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="fieldsAssigned" label="Fields Assigned" rules={[{ required: true }]}>
            <Select mode="multiple" style={{ width: '100%' }} placeholder="Select fields to assign">
              <Select.OptGroup label="Routes">
                {routeOptions.map(option => (
                  <Select.Option key={option} value={option}>{option}</Select.Option>
                ))}
              </Select.OptGroup>
              <Select.OptGroup label="Sub Permissions">
                {subPermissionOptions.map(option => (
                  <Select.Option key={option} value={option}>{option}</Select.Option>
                ))}
              </Select.OptGroup>
            </Select>
          </Form.Item>

        </Form>
      </Modal>

    </div>
  );
};

export default RoleFieldAssignmentPage;
